import React from "react";

import PracticeAddress from "../PracticeAddress/PracticeAddress";

const PracticeAddresses = (props) => {

    const addressText = props.addresses.map((address, index) => {
        return <PracticeAddress key={index} address={address} />;
    });

    return (
        <React.Fragment>
            {addressText}
        </React.Fragment>
    );
}

export default PracticeAddresses;